import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'asNumberArray',
})
export class AsNumberArrayPipe implements PipeTransform {
  transform(value: any, args?: any): Array<Number> {
    return value.map(s => parseFloat(s.toString()));
  }
}
